import { render, staticRenderFns } from "./GoogleDriveChannelDetail.vue?vue&type=template&id=99810b76&scoped=true"
import script from "./GoogleDriveChannelDetail.vue?vue&type=script&lang=js"
export * from "./GoogleDriveChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./GoogleDriveChannelDetail.vue?vue&type=style&index=0&id=99810b76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99810b76",
  null
  
)

export default component.exports